import {
  HomeIcon,
  CalendarDaysIcon,
  BeakerIcon,
  ClipboardDocumentListIcon,
  UserGroupIcon,
  HeartIcon,
  Cog6ToothIcon,
  BellAlertIcon,
  ArchiveBoxIcon,
  DocumentTextIcon,
  PresentationChartLineIcon,
  CurrencyDollarIcon,
} from '@heroicons/react/24/outline';

export const sectionShortcuts = [
  { name: 'عملیات روزانه', href: '/ops', icon: HomeIcon },
  { name: 'دام‌ها', href: '/cows', icon: UserGroupIcon },
  { name: 'باروری', href: '/repro', icon: HeartIcon },
  { name: 'سلامت', href: '/health', icon: BeakerIcon },
  { name: 'فهرست‌ها', href: '/lists', icon: ClipboardDocumentListIcon },
  { name: 'گزارش', href: '/reports', icon: PresentationChartLineIcon },
  { name: 'تحلیل مدیریتی', href: '/reports/decision-analytics', icon: PresentationChartLineIcon },
  { name: 'اقتصادی', href: '/economic', icon: CurrencyDollarIcon },
  { name: 'خوراک و موجودی', href: '/feed-dashboard', icon: ArchiveBoxIcon },
  { name: 'تنظیمات', href: '/settings', icon: Cog6ToothIcon },
];


export const dailyNavigationConfig = [
  {
    name: 'خانه و کارهای امروز',
    icon: HomeIcon,
    children: [
      { name: 'پیشخوان مدیریتی', href: '/', icon: HomeIcon },
      { name: 'مرکز عملیات روزانه', href: '/ops' },
      { name: 'برنامه روزانه', href: '/daily-plan' },
      { name: 'هشدارهای عملیاتی', href: '/alerts', icon: BellAlertIcon },
      { name: 'مرکز اقدام اصلاحی', href: '/alerts/corrective-center', icon: BellAlertIcon, permission: 'can_view_management_reports' },
      { name: 'تصمیم‌یار سناریوها', href: '/management/scenarios', icon: PresentationChartLineIcon, permission: 'can_view_management_reports' },
      { name: 'مرکز مدل‌های پیش‌بینی', href: '/management/predictive-models', icon: PresentationChartLineIcon, permission: 'can_view_management_reports' },
    ],
  },
  {
    name: 'دام‌ها',
    icon: UserGroupIcon,
    children: [
      { name: 'فهرست دام‌ها', href: '/cows' },
      { name: 'مشخصات انفرادی دام', href: '/cows/individual' },
      { name: 'باهاربندها', href: '/baharbands' },
      { name: 'ظرفیت جایگاه‌ها و جریان گله', href: '/herd/capacity-flow', permission: 'can_view_management_reports' },
      { name: 'تلفات و خروج دام', href: '/livestock-exit-events' },
      { name: 'کالبدشکافی تلفات', href: '/livestock-mortality-necropsy', permission: ['livestock_exit_events.view', 'livestock_exit_events.create', 'livestock_exit_events.edit'] },
    ],
  },
  {
    name: 'باروری',
    icon: HeartIcon,
    children: [
      { name: 'مرکز باروری', href: '/repro' },
      { name: 'کارتابل باروری', href: '/repro/planner' },
      { name: 'ثبت فحلی', href: '/estrus/new', permission: 'estrus.create' },
      { name: 'ویزیت دامپزشکی', href: '/repro/vet-visit' },
      { name: 'ثبت تلقیح', href: '/repro/services' },
      { name: 'آبستنی‌سنجی', href: '/repro/pregnancy-checks' },
      { name: 'ثبت زایش', href: '/repro/calvings' },
      { name: 'بازدید مجدد', href: '/repro/revisits' },
    ],
  },
  {
    name: 'سلامت و درمان',
    icon: BeakerIcon,
    children: [
      { name: 'مرکز سلامت', href: '/health' },
      { name: 'میز سلامت و درمان', href: '/health/workbench' },
      { name: 'بیمارستان گاوها', href: '/health/hospital', permission: 'hospital_admissions.view' },
      { name: 'برگه درمان گاوها', href: '/cow-treatment-sheets' },
      { name: 'پایش تازه‌زاها', href: '/fresh-cow-monitoring', permission: 'fresh_cow_checks.view' },
      { name: 'سلامت پستان', href: '/udder-health', permission: 'udder_health.view' },
      { name: 'لنگش و سم‌چینی', href: '/lameness-events', permission: 'lameness_events.view' },
    ],
  },
  {
    name: 'شیر و تولید',
    icon: DocumentTextIcon,
    children: [
      { name: 'رکورد شیر', href: '/milk-records' },
      { name: 'فروش شیر', href: '/phase4/milk-sales', permission: 'milk_sales.view' },
      { name: 'عملکرد شیر بهاربندها', href: '/milk-baharband-performance' },
      { name: 'کیفیت شیر', href: '/milk-quality-report' },
      { name: 'تحلیل پیشرفته شیر', href: '/milk-advanced-analytics', permission: 'milk_reports.view' },
    ],
  },
  {
    name: 'گوساله',
    icon: UserGroupIcon,
    children: [
      { name: 'فهرست گوساله‌ها', href: '/calves' },
      { name: 'کارهای روزانه گوساله‌دانی', href: '/calf-daily-tasks' },
      { name: 'برگه درمان گوساله‌ها', href: '/calf-treatment-sheets' },
      { name: 'رویدادهای گوساله', href: '/calf-events' },
      { name: 'مصرف شیر گوساله', href: '/calf-milk-records' },
      { name: 'وزن‌گیری و رشد', href: '/calf-growth-weighings' },
    ],
  },
  {
    name: 'خوراک و انبار',
    icon: ArchiveBoxIcon,
    children: [
      { name: 'داشبورد خوراک', href: '/feed-dashboard', permission: 'inventory_reports.view' },
      { name: 'ثبت سریع مصرف خوراک', href: '/feed-daily-fast-entry', permission: 'feed_operations.view' },
      { name: 'انبار خوراک', href: '/feed-inventory', permission: 'feed_inventory.view' },
      { name: 'جیره و ترکیب خوراک', href: '/feed-rations', permission: 'feed_operations.view' },
      { name: 'مصرف خوراک باسکول', href: '/feed-scale-tickets', permission: 'feed_operations.view' },
      { name: 'گزارش مدیریتی خوراک', href: '/feed-management-reports', permission: 'inventory_reports.view' },
    ],
  },
  {
    name: 'گزارش‌ها',
    icon: PresentationChartLineIcon,
    children: [
      { name: 'مرکز گزارش‌ها', href: '/reports' },
      { name: 'اتاق فرمان مدیریتی', href: '/reports/management-cockpit', permission: 'reports.view' },
      { name: 'مرکز شاخص‌های تحلیلی', href: '/reports/kpi-center' },
      { name: 'مرکز تحلیل و تصمیم‌گیری مدیر', href: '/reports/decision-analytics', permission: 'management_reports.view' },
      { name: 'آزمایشگاه تحلیل', href: '/reports/analytics-lab', permission: 'analytics_lab.view' },
      { name: 'تحلیل چرخه باروری', href: '/reports/pregnancy-cycles', permission: 'pregnancy_cycles.view' },
      { name: 'مرکز کیفیت داده', href: '/data-quality', permission: 'data_quality.view' },
      { name: 'گزارش جامع گله', href: '/reports/herd-dashboard', permission: 'reports.view' },
      { name: 'گزارش مدیریتی جلسه', href: '/reports/management-executive', permission: 'reports.view' },
    ],
  },
  {
    name: 'مدیریت سامانه',
    icon: Cog6ToothIcon,
    children: [
      { name: 'سوابق ورود اطلاعات اکسل', href: '/import-jobs', permission: ['can_view_audit_logs', 'services.view', 'pregnancy_checks.view', 'dryoffs.view', 'calvings.view', 'semen_inventory.view', 'feed_master_data.view', 'feed_inventory.view', 'feed_operations.view', 'inventory_documents.view'] },
      { name: 'اشخاص عملیاتی', href: '/operational-people', permission: 'operational_people.view' },
      { name: 'تنظیمات سامانه', href: '/settings', adminOnly: true },
      { name: 'پشتیبان‌گیری', href: '/settings/backups', permission: 'system_backups.view' },
    ],
  },
];

export const navigationConfig = [
  {
    name: 'عملیات روزانه',
    icon: HomeIcon,
    children: [
      { name: 'پیشخوان مدیریتی', href: '/', icon: HomeIcon },
      { name: 'مرکز عملیات روزانه', href: '/ops', icon: HomeIcon },
      { name: 'برنامه روزانه', href: '/daily-plan', icon: CalendarDaysIcon },
      { name: 'هشدارهای عملیاتی', href: '/alerts', icon: BellAlertIcon },
    ],
  },
  {
    name: 'دام‌ها',
    icon: UserGroupIcon,
    children: [
      { name: 'همه دام‌ها', href: '/cows' },
      { name: 'پاکسازی شماره گوش تکراری', href: '/cows/duplicates' },
      { name: 'گزارش تاریخچه جابجایی دام', href: '/cows/movement-history' },
      { name: 'تاریخچه روزانه وضعیت گله', href: '/cows/daily-herd-snapshots', permission: 'cows.view' },
      { name: 'تحلیل چندساله اسنپ‌شات گله', href: '/reports/herd-snapshot-history', permission: 'reports.view' },
      { name: 'مشخصات انفرادی دام', href: '/cows/individual' },
      { name: 'باهاربندها', href: '/baharbands' },
      { name: 'ظرفیت جایگاه‌ها و جریان گله', href: '/herd/capacity-flow', permission: 'can_view_management_reports' },
      { name: 'اسناد دام', href: '/cow-documents' },
      { name: 'عکس و اسکیج گوساله', href: '/calf-photo-sketches' },
      { name: 'سوابق جستجوی تصویری گوساله', href: '/calf-image-search-history' },
      { name: 'تلفات و خروج دام', href: '/livestock-exit-events' },
      { name: 'کالبدشکافی تلفات', href: '/livestock-mortality-necropsy', permission: ['livestock_exit_events.view', 'livestock_exit_events.create', 'livestock_exit_events.edit'] },
      { name: 'فروش دام‌های حذفی', href: '/phase4/livestock-sales', permission: 'can_manage_financial_data' },
    ],
  },
  {
    name: 'باروری',
    icon: HeartIcon,
    children: [
      {
        name: 'ثبت و عملیات باروری',
        icon: ClipboardDocumentListIcon,
        children: [
          { name: 'مرکز باروری', href: '/repro' },
          { name: 'کارتابل باروری', href: '/repro/planner' },
          { name: 'ثبت فحلی', href: '/estrus/new', permission: 'estrus.create' },
          { name: 'ویزیت دامپزشکی', href: '/repro/vet-visit' },
          { name: 'لیست سونوگرافی دامپزشک', href: '/repro/visit-plans' },
          { name: 'ثبت تلقیح / سرویس', href: '/repro/services' },
          { name: 'آبستنی‌سنجی', href: '/repro/pregnancy-checks' },
          { name: 'ثبت سقط', href: '/repro/abortions' },
          { name: 'ثبت خشکی', href: '/repro/dryoffs' },
          { name: 'ثبت زایش', href: '/repro/calvings' },
        ],
      },
      {
        name: 'گزارش و پیگیری باروری',
        icon: PresentationChartLineIcon,
        children: [
          { name: 'گزارشات جامع و تحلیل باروری', href: '/repro/reports' },
          { name: 'گزارش‌های کلاسیک باروری', href: '/repro/reports/legacy-fertility', permission: 'repro_reports.view' },
          { name: 'فهرست فحلی‌ها', href: '/estrus' },
          { name: 'گزارش بازدید مجدد', href: '/repro/revisits' },
          { name: 'گزارش روزهای پس از تلقیح', href: '/repro/service-days-range' },
          { name: 'گاوهای ول شیری از نظر باروری', href: '/repro/fertility-neglected-milking', permission: 'repro_reports.view' },
          { name: 'گزارش اطلاعات زایش', href: '/repro/calving-information', permission: 'repro_reports.view' },
          { name: 'پیش‌بینی زایش ماه‌های آینده', href: '/repro/calving-forecast' },
          { name: 'خط زمانی باروری', href: '/repro/timeline' },
        ],
      },
      {
        name: 'هورمون‌تراپی باروری',
        icon: BeakerIcon,
        children: [
          { name: 'چرخه‌های هورمون‌تراپی', href: '/repro/hormone-therapy' },
          { name: 'ثبت هورمون‌تراپی جدید', href: '/repro/hormone-therapy/new', permission: 'treatments.create' },
          { name: 'پروتکل‌های هورمون‌تراپی', href: '/repro/hormone-therapy-protocols' },
        ],
      },
      {
        name: 'اسپرم و انبار باروری',
        icon: ArchiveBoxIcon,
        children: [
          { name: 'انبار اسپرم', href: '/repro/semen-inventory' },
          { name: 'انتخاب اسپرم از اکسل', href: '/repro/semen-inventory?tab=import&section=cow-plans' },
          { name: 'موقعیت‌های نگهداری اسپرم', href: '/semen-storage-positions', permission: 'feed_master_data.view' },
        ],
      },
    ],
  },
  {
    name: 'سلامت و درمان',
    icon: BeakerIcon,
    children: [
      {
        name: 'عملیات درمان و سلامت',
        icon: ClipboardDocumentListIcon,
        children: [
          { name: 'مرکز سلامت', href: '/health' },
          { name: 'اتاق فرمان سلامت گله', href: '/vet-command-center', permission: 'vet_command_center.view' },
          { name: 'میز سلامت و درمان', href: '/health/workbench' },
          { name: 'بیمارستان گاوها', href: '/health/hospital', permission: 'hospital_admissions.view' },
          { name: 'پایش تازه‌زاهای ۳۰ روز اول', href: '/fresh-cow-monitoring', permission: 'fresh_cow_checks.view' },
          { name: 'آزمایشگاه دامپزشکی', href: '/lab-tests', permission: 'lab_tests.view' },
          { name: 'برگه درمان بیمارستانی گاوها', href: '/cow-treatment-sheets' },
          { name: 'ثبت درمان بیمارستانی جدید', href: '/cow-treatment-sheets?openCreate=1', permission: 'cow_treatment_sheets.create' },
          { name: 'ثبت تجویز گروهی', href: '/cow-treatment-sheets?openCreate=1' },
          { name: 'ثبت BCS', href: '/cows?bcs=1' },
          { name: 'ثبت واکسیناسیون و تیترگیری', href: '/preventive-care', permission: ['preventive_care.view', 'preventive_care.create', 'preventive_care.edit'] },
          { name: 'سلامت پستان و کارتیه‌ها', href: '/udder-health', permission: 'udder_health.view' },
          { name: 'لنگش و سم‌چینی', href: '/lameness-events', permission: 'lameness_events.view' },
          { name: 'ثبت جراحی‌های گاو', href: '/cow-surgeries', permission: ['cow_surgeries.view', 'cow_surgeries.create', 'cow_surgeries.edit'] },
        ],
      },
      {
        name: 'گزارش‌های سلامت',
        icon: PresentationChartLineIcon,
        children: [
          { name: 'گزارش سلامت دامپزشکی', href: '/repro/vet-health-report' },
          { name: 'سابقه درمان گاو در دوره آخر', href: '/cow-treatment-history', permission: ['cow_treatment_history.view', 'cow_treatment_sheets.view', 'health_reports.view'] },
          { name: 'گزارش تخصصی پستان و لنگش', href: '/repro/udder-lameness-report', permission: 'health_reports.view' },
          { name: 'گزارش پرهیز شیر و گوشت', href: '/medication-withdrawal-report', permission: 'health_reports.view' },
          { name: 'هشدارهای دامپزشکی هوشمند', href: '/vet-smart-alerts', permission: 'alerts.view' },
          { name: 'تحلیل موفقیت درمان', href: '/treatment-outcome-analytics', permission: 'health_reports.view' },
          { name: 'تحلیل اثر سلامت بر شیر', href: '/milk-health-impact', permission: 'milk_reports.view' },
          { name: 'تحلیل اثر سلامت بر باروری', href: '/fertility-health-impact', permission: 'repro_reports.view' },
          { name: 'مقایسه باهاربندها و هشدارهای عملیاتی', href: '/repro/udder-lameness-operations', permission: 'health_reports.view' },
          { name: 'خلاصه واحد دامپزشکی', href: '/repro/vet-phase2-summary' },
        ],
      },
      {
        name: 'تعاریف سلامت',
        icon: DocumentTextIcon,
        children: [
          { name: 'پروتکل‌های آماده درمان گاو', href: '/cow-treatment-protocols' },
          { name: 'تعاریف پایه جراحی گاو', href: '/cow-surgery-master-data', permission: 'cow_surgeries.view' },
          { name: 'بیماری‌ها و نواحی درگیر', href: '/disease-master-data' },
          { name: 'داروها', href: '/drugs' },
          { name: 'بچ‌های دارویی و انقضا', href: '/drug-lots', permission: 'drugs.view' },
          { name: 'پروتکل واکسن', href: '/vaccination-protocols', permission: ['vaccination_protocols.view', 'vaccination_protocols.create', 'vaccination_protocols.edit'] },
        ],
      },
    ],
  },
  {
    name: 'شیر و تولید',
    icon: DocumentTextIcon,
    children: [
      { name: 'رکورد شیر', href: '/milk-records' },
      { name: 'تعریف طرف حساب‌ها', href: '/counterparties', permission: ['counterparties.view', 'milk_sales.view', 'financial_data.view'] },
      { name: 'فروش شیر', href: '/phase4/milk-sales', permission: 'milk_sales.view' },
      { name: 'فروش شیر روزانه و تحلیل بهاربندها', href: '/milk-baharband-performance' },
      { name: 'گزارش کیفیت شیر', href: '/milk-quality-report' },
      { name: 'تحلیل پیشرفته شیر', href: '/milk-advanced-analytics', permission: 'milk_reports.view' },
      { name: 'منحنی شیردهی', href: '/cows/:id/lactation-curve' },
    ],
  },
  {
    name: 'گوساله',
    icon: UserGroupIcon,
    children: [
      {
        name: 'عملیات و ثبت گوساله',
        icon: ClipboardDocumentListIcon,
        children: [
          { name: 'فهرست گوساله‌ها', href: '/calves' },
          { name: 'عکس دو طرف و اسکیج گوساله', href: '/calf-photo-sketches' },
          { name: 'سوابق جستجوی تصویری گوساله', href: '/calf-image-search-history' },
          { name: 'کارهای روزانه گوساله‌دانی', href: '/calf-daily-tasks' },
          { name: 'برد اجرایی درمان گوساله‌ها', href: '/calf-treatment-ops' },
          { name: 'برگه درمان گوساله‌ها', href: '/calf-treatment-sheets' },
          { name: 'رویدادهای گوساله', href: '/calf-events' },
          { name: 'شاخ‌سوزی گوساله‌ها', href: '/calf-events?event_type=dehorning' },
          { name: 'ثبت مصرف شیر گوساله', href: '/calf-milk-records' },
          { name: 'وزن‌گیری گروهی و ADG', href: '/calf-growth-weighings' },
          { name: 'خوراک گوساله‌ها بر اساس بهاربند و سن', href: '/calf-feed-age-intake', permission: ['calf_reports.view', 'feed_operations.view'] },
        ],
      },
      {
        name: 'تعاریف پایه گوساله',
        icon: DocumentTextIcon,
        children: [
          { name: 'پروتکل‌های درمان گوساله', href: '/calf-treatment-protocols' },
          { name: 'پروتکل شیردهی گوساله', href: '/calf-milk-protocols' },
          { name: 'علل تلفات / خروج دام', href: '/livestock-exit-causes' },
        ],
      },
      {
        name: 'گزارش‌گیری گوساله',
        icon: PresentationChartLineIcon,
        children: [
          { name: 'داشبورد تحلیل جامع گوساله‌دانی', href: '/calf-analytics' },
          { name: 'تحلیل رشد، بقا و اقتصاد گوساله', href: '/calf-growth-analytics', permission: 'calf_reports.view' },
          { name: 'امتیازدهی بالینی گوساله', href: '/calf-clinical-scoring' },
          { name: 'سوابق درمانی گوساله', href: '/calf-treatment-history', permission: ['calf_reports.view', 'calf_treatment_sheets.view', 'calf_treatment_sheets.create', 'calf_treatment_sheets.edit', 'health_reports.view'] },
          { name: 'گزارش مالی درمان گوساله', href: '/calf-treatment-financial' },
          { name: 'گزارش ماهانه شیر گوساله', href: '/calf-milk-monthly-report' },
          { name: 'گزارش تلفات گوساله تا ۹۰ روز', href: '/calf-mortality-report' },
          { name: 'مرکز گزارشات گوساله‌دانی', href: '/reports/calf', permission: 'reports.view' },
        ],
      },
    ],
  },
  {
    name: 'فهرست‌ها',
    icon: ClipboardDocumentListIcon,
    children: [
      { name: 'مرکز فهرست‌ها', href: '/lists' },
      { name: 'فهرست‌های ذخیره‌شده', href: '/lists/saved?tab=saved' },
      { name: 'الگوهای فهرست', href: '/lists/saved?tab=templates' },
      { name: 'سازنده فهرست', href: '/lists/saved?tab=builder' },
    ],
  },
  {
    name: 'خوراک و موجودی',
    icon: ArchiveBoxIcon,
    children: [
      {
        name: 'خوراک',
        icon: ClipboardDocumentListIcon,
        children: [
          { name: 'داشبورد خوراک', href: '/feed-dashboard', permission: 'inventory_reports.view' },
          { name: 'راهنمای شروع خوراک', href: '/feed-start-guide', permission: ['feed_master_data.view', 'feed_inventory.view', 'feed_operations.view', 'inventory_reports.view'] },
          { name: 'ایمپورت اکسل خوراک', href: '/feed-excel-import', permission: ['feed_master_data.view', 'feed_inventory.view', 'feed_operations.view', 'procurement.view'] },
          { name: 'خوراک، انبار و فرمول جیره', href: '/feed-nutrition-inventory', permission: ['feed_master_data.view', 'feed_inventory.view', 'feed_operations.view', 'inventory_reports.view'] },
          { name: 'اتصال جیره به بهاربند', href: '/feed-baharband-rations', permission: ['feed_operations.view', 'baharbands.view'] },
          { name: 'ثبت سریع مصرف روزانه خوراک', href: '/feed-daily-fast-entry', permission: 'feed_operations.view' },
          { name: 'گزارش‌های مدیریتی خوراک', href: '/feed-management-reports', permission: 'inventory_reports.view' },
          { name: 'تحلیل عملکرد خوراک و شیر', href: '/feed-performance-analytics', permission: 'inventory_reports.view' },
          { name: 'داشبورد هشدار خوراک', href: '/feed-alert-dashboard', permission: 'inventory_reports.view' },
          { name: 'خوراک گوساله‌ها بر اساس بهاربند و سن', href: '/calf-feed-age-intake', permission: ['calf_reports.view', 'feed_operations.view'] },
          { name: 'IOFC دام‌ها', href: '/feed-iofc', permission: 'inventory_reports.view' },
          { name: 'انبار خوراک', href: '/feed-inventory', permission: 'feed_inventory.view' },
          { name: 'خرید خوراک', href: '/feed-purchases', permission: 'procurement.view' },
          { name: 'جیره و ترکیب کنسانتره / TMR', href: '/feed-rations', permission: 'feed_operations.view' },
          { name: 'مصرف برنامه‌ای خوراک', href: '/feed-planned-consumptions', permission: 'feed_operations.view' },
          { name: 'مصرف خوراک باسکول', href: '/feed-scale-tickets', permission: 'feed_operations.view' },
          { name: 'ثبت جمعی خوراک', href: '/feed-scale-distributions', permission: 'feed_operations.view' },
          { name: 'مصرف دستی خوراک', href: '/feed-consumptions', permission: 'feed_operations.view' },
          { name: 'ضایعات خوراک', href: '/feed-wastes', permission: 'feed_operations.view' },
          { name: 'افت خوراک', href: '/feed-losses', permission: 'feed_operations.view' },
          { name: 'پسماند خوراک', href: '/feed-residuals', permission: 'feed_operations.view' },
          { name: 'سربار خوراک', href: '/feed-overheads', permission: 'feed_operations.view' },
          { name: 'هزینه عملیاتی خوراک', href: '/feed-operational-cost', permission: 'feed_operations.view' },
        ],
      },
      {
        name: 'موجودی و تدارکات',
        icon: ArchiveBoxIcon,
        children: [
          { name: 'انبار مواد مصرفی', href: '/supply-inventory' },
          { name: 'خرید مواد مصرفی', href: '/supply-purchases' },
          { name: 'مصرف مواد مصرفی', href: '/supply-consumptions' },
          { name: 'درخواست‌های خرید', href: '/purchase-requests', permission: 'can_manage_procurement' },
          { name: 'سفارش‌های خرید', href: '/purchase-orders', permission: 'can_manage_procurement' },
          { name: 'رسیدهای انبار', href: '/goods-receipts', permission: 'can_manage_inventory_documents' },
          { name: 'موجودی اولیه', href: '/opening-inventories', permission: 'can_manage_inventory_documents' },
          { name: 'شمارش موجودی', href: '/stock-counts', permission: 'can_manage_inventory_documents' },
          { name: 'موجودی لحظه‌ای', href: '/inventory-on-hand', permission: 'can_view_inventory_reports' },
          { name: 'هشدارهای انبار', href: '/inventory-alerts', permission: 'can_view_inventory_reports' },
        ],
      },
      {
        name: 'تعاریف خوراک و موجودی',
        icon: DocumentTextIcon,
        children: [
          { name: 'مواد غذایی', href: '/feed-items', permission: 'feed_master_data.view' },
          { name: 'دسته‌بندی مواد غذایی', href: '/feed-categories', permission: 'feed_master_data.view' },
          { name: 'گروه‌های تغذیه', href: '/feeding-groups', permission: 'feed_master_data.view' },
          { name: 'علت ضایعات خوراک', href: '/feed-waste-causes', permission: 'feed_master_data.view' },
          { name: 'علت افت خوراک', href: '/feed-loss-causes', permission: 'feed_master_data.view' },
          { name: 'علت پسماند خوراک', href: '/feed-residual-causes', permission: 'feed_master_data.view' },
          { name: 'انواع سربار خوراک', href: '/feed-overhead-types', permission: 'feed_master_data.view' },
          { name: 'تأمین‌کننده‌ها', href: '/suppliers', permission: 'feed_master_data.view' },
          { name: 'طرف حساب‌ها', href: '/counterparties', permission: ['counterparties.view', 'milk_sales.view', 'financial_data.view'] },
          { name: 'محل‌های نگهداری', href: '/storage-locations', permission: 'feed_master_data.view' },
        ],
      },
    ],
  },
  {
    name: 'گزارش و شاخص‌ها',
    icon: PresentationChartLineIcon,
    children: [
      { name: 'مرکز جامع گزارشات دام‌یار', href: '/reports' },
      { name: 'مرکز شاخص‌های تحلیلی', href: '/reports/kpi-center' },
      { name: 'مرکز تحلیل و تصمیم‌گیری مدیر', href: '/reports/decision-analytics', permission: 'management_reports.view' },
      { name: 'آزمایشگاه تحلیل', href: '/reports/analytics-lab', permission: 'analytics_lab.view' },
      { name: 'تحلیل چرخه باروری', href: '/reports/pregnancy-cycles', permission: 'pregnancy_cycles.view' },
      { name: 'مرکز کیفیت داده', href: '/data-quality', permission: 'data_quality.view' },
      {
        name: 'گزارشات عملیاتی',
        icon: ClipboardDocumentListIcon,
        children: [
          { name: 'مرکز گزارشات عملیاتی', href: '/reports/operational' },
          { name: 'فاز ۲ عملیاتی باروری', href: '/reports/operational/phase2' },
          { name: 'منفی PD بدون اقدام', href: '/reports/operational/phase2?section=open_pd_no_next_action' },
          { name: 'فحلی‌های باز', href: '/reports/operational/phase2?section=open_estrus' },
          { name: 'فحل/کاندید تلقیح نشده', href: '/reports/operational/phase2?section=skipped_insemination' },
          { name: 'دام‌های بدون برنامه', href: '/reports/operational/phase2?section=no_program' },
          { name: 'برنامه آبستنی‌سنجی', href: '/reports/operational/phase2?section=pd_due' },
          { name: 'بازدید مجدد دکتر', href: '/reports/operational/phase2?section=revisits_due' },
          { name: 'پروتکل‌های امروز', href: '/reports/operational/phase2?section=protocol_today' },
          { name: 'پروتکل‌های عقب‌افتاده', href: '/reports/operational/phase2?section=protocol_overdue' },
        ],
      },
      {
        name: 'گزارشات تحلیلی',
        icon: PresentationChartLineIcon,
        children: [
          { name: 'مرکز تحلیل‌ها', href: '/reports/analytical' },
          { name: 'فاز ۴ تحلیل تخصصی باروری', href: '/reports/analytical/fertility' },
          { name: 'فاز ۵ تحلیل شیر، سلامت و گوساله', href: '/reports/analytical/production-health-calf' },
          { name: 'تحلیل زایمان و دوره انتقال', href: '/reports/analytical/calving-transition' },
          { name: 'DIM، روزهای باز و سن تلقیح تلیسه', href: '/reports/analytical/lactation-heifer' },
          { name: 'رابطه سن تلقیح تلیسه با مدت آبستنی', href: '/reports/analytical/heifer-service-age-gestation' },
          { name: 'مرکز گزارشات گوساله‌دانی', href: '/reports/calf', permission: 'reports.view' },
          { name: 'فاز ۶ تحلیل بهاربند، افراد و کیفیت داده', href: '/reports/analytical/baharband-people-quality' },
          { name: 'فاز ۱۵ پیش‌بینی و ریسک‌سنجی گله', href: '/reports/predictive-risk', permission: 'reports.view' },
          { name: 'بهاربندهای مشکل‌دار', href: '/reports/analytical/baharband-people-quality?section=baharbands' },
          { name: 'تحلیل عملکرد افراد', href: '/reports/analytical/baharband-people-quality?section=people' },
          { name: 'کیفیت داده و مغایرت‌ها', href: '/reports/analytical/baharband-people-quality?section=quality' },
          { name: 'تحلیل تکنسین تلقیح', href: '/reports/analytical/fertility?section=technician' },
          { name: 'تحلیل اسپرم و بچ', href: '/reports/analytical/fertility?section=semen' },
          { name: 'تحلیل DIM و شکم زایش', href: '/reports/analytical/fertility?section=dim' },
          { name: 'رابطه سن تلقیح تلیسه با گیرایی', href: '/reports/analytical/lactation-heifer?section=heifer_age' },
          { name: 'پیک شیر بعد از تلقیح تلیسه', href: '/reports/analytical/lactation-heifer?section=heifer_rows' },
          { name: 'ماک، جفت‌ماندگی و سخت‌زایی', href: '/reports/analytical/calving-transition?section=parity' },
          { name: 'اثر زایش روی گیرایی دوره بعد', href: '/reports/analytical/calving-transition?section=repro' },
          { name: 'اثر زایش روی پیک شیر', href: '/reports/analytical/calving-transition?section=milk' },
          { name: 'تحلیل پروتکل باروری', href: '/reports/analytical/fertility?section=protocol' },
          { name: 'Repeat Breeder', href: '/reports/analytical/fertility?section=repeat' },
          { name: 'تحلیل کلی گله', href: '/reports/analytical?section=overview' },
          { name: 'تحلیل باروری پایه', href: '/reports/analytical?section=reproduction' },
          { name: 'تحلیل شیر', href: '/reports/analytical?section=milk' },
          { name: 'تحلیل درمان و سلامت', href: '/reports/analytical?section=health' },
          { name: 'تحلیل گوساله‌ها', href: '/reports/analytical?section=calves' },
          { name: 'تحلیل بهاربندها', href: '/reports/analytical?section=baharbands' },
          { name: 'تحلیل کیفیت داده‌ها', href: '/reports/analytical?section=quality' },
        ],
      },
      { name: 'اتاق فرمان مدیریتی پویا', href: '/reports/management-cockpit', permission: 'reports.view' },
      { name: 'داشبورد جامع عملکرد گله', href: '/reports/herd-dashboard', permission: 'reports.view' },
      { name: 'گزارش مدیریتی جامع جلسه', href: '/reports/management-executive', permission: 'reports.view' },
      { name: 'فاز ۹ مرکز هشدار هوشمند', href: '/reports/smart-alert-center', permission: 'reports.view' },
      { name: 'فاز ۱۰ تنظیم اهداف و هشدارها', href: '/reports/management-settings', permission: 'reports.view' },
      { name: 'فاز ۱۱ گزارش‌ساز سفارشی', href: '/reports/custom-builder', permission: 'reports.view' },
      { name: 'فاز ۱۲ سرعت و کش گزارشات', href: '/reports/performance-center', permission: 'reports.view' },
      { name: 'فاز ۱۳ تاریخچه چندساله گله', href: '/reports/herd-snapshot-history', permission: 'reports.view' },
      { name: 'فاز ۱۴ تحلیل اقتصادی و حذف دام', href: '/reports/management-economic-decision', permission: 'reports.view' },
      { name: 'فاز ۱۵ پیش‌بینی و ریسک‌سنجی گله', href: '/reports/predictive-risk', permission: 'reports.view' },

      { name: 'مقایسه سایت / واحد', href: '/reports/site-comparison' },
      { name: 'خلاصه عملیاتی فاز ۳', href: '/phase3/operational-summary', permission: 'can_view_inventory_reports' },
      { name: 'داشبورد مدیریتی', href: '/phase4/executive-dashboard', permission: 'can_view_management_reports' },
      { name: 'تحلیل هزینه مدیریتی', href: '/phase4/management-cost-analysis', permission: 'can_view_management_reports' },
      { name: 'تحلیل سودآوری', href: '/phase4/profitability-analysis', permission: 'can_view_management_reports' },
      { name: 'فاز ۲۵ موتور مالی مرکزی', href: '/finance/engine', permission: 'can_view_management_reports' },
      { name: 'فاز ۲۶ حذف اقتصادی و جایگزینی', href: '/finance/culling-replacement', permission: 'can_view_management_reports' },
      { name: 'فاز ۲۷ ظرفیت جایگاه و جریان گله', href: '/herd/capacity-flow', permission: 'can_view_management_reports' },
      { name: 'فاز ۲۸ هشدار و اقدام اصلاحی', href: '/alerts/corrective-center', permission: 'can_view_management_reports' },
      { name: 'فاز ۲۹ تحلیل سناریو و تصمیم‌یار', href: '/management/scenarios', permission: 'can_view_management_reports' },
      { name: 'فاز ۳۰ مدل‌های پیش‌بینی و ریسک', href: '/management/predictive-models', permission: 'can_view_management_reports' },
    ],
  },
  {
    name: 'اقتصادی و سودآوری',
    icon: CurrencyDollarIcon,
    children: [
      { name: 'میز اقتصادی', href: '/economic' },
      { name: 'کارگاه اقتصادی', href: '/economic/workbench' },
      { name: 'فاز ۱۴ تحلیل اقتصادی و حذف دام', href: '/reports/management-economic-decision', permission: 'reports.view' },
      { name: 'فاز ۱۵ پیش‌بینی و ریسک‌سنجی گله', href: '/reports/predictive-risk', permission: 'reports.view' },
      { name: 'موتور مالی و بهای تمام‌شده', href: '/finance/engine', permission: 'can_view_management_reports' },
      { name: 'حذف اقتصادی، بقا و جایگزینی', href: '/finance/culling-replacement', permission: 'can_view_management_reports' },
      { name: 'ظرفیت جایگاه‌ها و جریان گله', href: '/herd/capacity-flow', permission: 'can_view_management_reports' },
      { name: 'مرکز هشدار و اقدام اصلاحی', href: '/alerts/corrective-center', permission: 'can_view_management_reports' },
      { name: 'تحلیل سناریو و تصمیم‌یار', href: '/management/scenarios', permission: 'can_view_management_reports' },
      { name: 'مدل‌های پیش‌بینی و ریسک‌سنجی', href: '/management/predictive-models', permission: 'can_view_management_reports' },
      { name: 'هزینه‌های عملیاتی', href: '/phase4/operating-expenses', permission: 'can_manage_financial_data' },
      { name: 'درآمدهای عملیاتی', href: '/phase4/revenue-entries', permission: 'can_manage_financial_data' },
      { name: 'مراکز هزینه', href: '/phase4/cost-centers', permission: 'can_manage_financial_data' },
      { name: 'قواعد تخصیص هزینه', href: '/phase4/allocation-rules', permission: 'can_manage_financial_data' },
    ],
  },
  {
    name: 'کنترل و مدیریت سامانه',
    icon: Cog6ToothIcon,
    children: [
      { name: 'لاگ ممیزی و ویرایش کلی', href: '/audit-logs', permission: 'can_view_audit_logs' },
      { name: 'خلاصه عملکرد روزانه کاربران', href: '/user-daily-activity', permission: 'can_view_audit_logs' },
      { name: 'سوابق ایمپورت اکسل', href: '/import-jobs', permission: ['can_view_audit_logs', 'services.view', 'pregnancy_checks.view', 'dryoffs.view', 'calvings.view', 'semen_inventory.view', 'feed_master_data.view', 'feed_inventory.view', 'feed_operations.view', 'inventory_documents.view'] },
      { name: 'تنظیمات سامانه', href: '/settings', adminOnly: true },
      { name: 'اشخاص عملیاتی دامداری', href: '/operational-people', permission: 'operational_people.view' },
      { name: 'پشتیبان‌گیری حرفه‌ای', href: '/settings/backups', permission: 'system_backups.view' },
      { name: 'Power User / میان‌برها', href: '/settings/power-user' },
      { name: 'پروتکل‌های هورمون‌تراپی', href: '/repro/hormone-therapy-protocols' },
    ],
  },
];

export function matchNavHref(href, pathname, search = '') {
  if (!href) return false;
  const [pathOnly, queryString = ''] = href.split('?');
  if (pathOnly.includes(':')) {
    const regex = new RegExp(`^${pathOnly.replace(/:[^/]+/g, '[^/]+')}$`);
    if (regex.test(pathname)) return true;
  }
  if (pathOnly === '/') {
    return pathname === '/' && (!queryString || search === `?${queryString}`);
  }
  if (queryString) {
    return pathname === pathOnly && search === `?${queryString}`;
  }
  return pathname === pathOnly || pathname.startsWith(`${pathOnly}/`);
}

export function flattenNavigation(items, trail = []) {
  return (items || []).flatMap((item) => {
    const nextTrail = [...trail, { name: item.name, href: item.href || null }];
    if (item.children?.length) return flattenNavigation(item.children, nextTrail);
    if (!item.href) return [];
    return [{ ...item, trail: nextTrail }];
  });
}

export function findNavigationTrail(items, pathname, search = '') {
  const flattened = flattenNavigation(items);
  const matches = flattened
    .filter((item) => matchNavHref(item.href, pathname, search))
    .sort((left, right) => (right.href?.length || 0) - (left.href?.length || 0));
  return matches[0]?.trail || [];
}


// افزوده‌های پچ نهایی یکپارچه دام‌یار: همه عنوان‌ها فارسی هستند.
export const damyarUnifiedReportLinks = [
  { title: 'مرکز گزارش‌های قدیمی', path: '/reports/legacy-center' },
  { title: 'گزارش‌های پیشرفته قدیمی', path: '/reports/legacy-advanced' },
  { title: 'گزارش‌ساز پویا', path: '/reports/dynamic-builder' },
  { title: 'اتاق فرمان مدیریتی پویا', path: '/reports/management-cockpit' },
  { title: 'گزارش‌ساز سفارشی فاز ۱۱', path: '/reports/custom-builder' },
  { title: 'مرکز سرعت و کش گزارشات فاز ۱۲', path: '/reports/performance-center' },
  { title: 'تحلیل تاریخچه چندساله گله فاز ۱۳', path: '/reports/herd-snapshot-history' },
  { title: 'تحلیل اقتصادی و تصمیم‌یار حذف دام فاز ۱۴', path: '/reports/management-economic-decision' },
  { title: 'پیش‌بینی و ریسک‌سنجی گله فاز ۱۵', path: '/reports/predictive-risk' },
  { title: 'مرکز تحلیل گزارش‌ها', path: '/reports/analytics-center' },
  { title: 'مرکز تحلیل و تصمیم‌گیری مدیر', path: '/reports/decision-analytics' },
  { title: 'تحلیل‌های مدیریتی پیشرفته', path: '/reports/advanced-analytics' },
  { title: 'تحلیل‌های سازمانی دام‌یار', path: '/reports/enterprise-analytics' },
];

export const damyarUnifiedSettingsLinks = [
  { title: 'تنظیمات پیامک کاوه‌نگار', path: '/settings/sms-notifications' },
];
